<template>
  <div class="hl-status">
    <!-- 展示图标 -->
    <i :class="['iconfont hl-status-icon', iconClass]" v-if="iconClass" :style="{ color }"></i>
    <!-- 展示传颜色圆点 -->
    <span class="hl-status-dot" v-else :style="{ backgroundColor: color }"></span>
    <span class="hl-status-text" v-if="text">{{ text }}</span>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    iconClass: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    _text() {
      if (this.$slots.default) {
        return this.$slots.default
      }
      if (this.text) {
        return this.text
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.hl-status {
  display: flex;
  align-items: center;
}
.hl-status-icon {
  font-size: 20px;
  margin-right: 4px;
  vertical-align: middle;
}
.hl-status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 4px;
}
.hl-status-text {
  margin-left: 4px;
  font-size: 14px;
  color: #333333;
  vertical-align: middle;
}
</style>
